import { createBrowserHistory } from 'history'

import routes from './config/routes'

export const history = createBrowserHistory({
    basename: routes.basename
})
